/* Окно входа. Панель модала здесь без своей шапки (Modal bare), поэтому все
   отступы задаются тут — от края панели до края содержимого. */

.head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-8) var(--sp-7) var(--sp-6);
  text-align: center;
  /* Мягкая подложка под знаком: единственное украшение окна, собрано из
     токенов темы, поэтому переживает смену палитры без правок. */
  background:
    radial-gradient(120% 120% at 50% 0%, var(--flight-bg) 0%, transparent 70%),
    var(--surface);
  border-bottom: var(--bw) solid var(--border);
}

@supports ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  /* На просвечивающей панели сплошная заливка шапки выглядит наклейкой. */
  .head {
    background: radial-gradient(120% 120% at 50% 0%, var(--flight-bg) 0%, transparent 70%);
  }
}

.logo {
  transform: scale(1.1);
}

.subtitle {
  margin: 0;
  max-width: 30ch;
  color: var(--text-2);
  font-size: var(--fs-sm);
  line-height: 1.45;
}

/* ── Вкладки «Вход» / «Регистрация» ──────────────────────────────────────── */

.tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-2);
  margin: var(--sp-6) var(--sp-7) 0;
  padding: var(--sp-1);
  background: var(--surface-sunken);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

.tab {
  padding: var(--sp-3) var(--sp-4);
  border: 0;
  border-radius: var(--radius);
  background: transparent;
  color: var(--text-2);
  font: inherit;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: background var(--dnd-dur) var(--dnd-ease), color var(--dnd-dur) var(--dnd-ease);
}

.tab:hover {
  color: var(--text);
}

.tabActive {
  background: var(--surface);
  color: var(--text);
  font-weight: 600;
  box-shadow: var(--shadow-card), var(--glow-accent);
}

.backRow {
  margin: var(--sp-6) var(--sp-7) 0;
}

.back {
  border: 0;
  background: none;
  padding: 0;
  color: var(--text-2);
  font: inherit;
  font-size: var(--fs-sm);
  cursor: pointer;
}

.back:hover {
  color: var(--text);
}

/* ── Форма ───────────────────────────────────────────────────────────────── */

.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  padding: var(--sp-6) var(--sp-7) var(--sp-5);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.labelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-4);
}

.label {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 500;
}

.inlineLink {
  border: 0;
  background: none;
  padding: 0;
  color: var(--flight);
  font: inherit;
  font-size: var(--fs-sm);
  cursor: pointer;
}

.inlineLink:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* Поля здесь крупнее общих .input: окно входа — первый экран продукта, и
   плотная сетка планировщика в нём выглядит канцелярски. */
.control {
  width: 100%;
  padding: var(--sp-4) var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  font: inherit;
  font-size: var(--fs-lg);
  color: inherit;
  transition: border-color var(--dnd-dur) var(--dnd-ease);
}

.control::placeholder {
  color: var(--text-3);
}

.control:hover {
  border-color: var(--text-3);
}

.inputWrap {
  position: relative;
  display: flex;
  align-items: center;
}

.controlWithButton {
  padding-right: calc(var(--sp-8) + var(--sp-2));
}

.reveal {
  position: absolute;
  right: var(--sp-3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--radius);
  background: none;
  color: var(--text-3);
  cursor: pointer;
}

.reveal:hover {
  color: var(--text);
  background: var(--surface-sunken);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.hintOk {
  color: var(--ok);
}

.capsHint {
  margin: 0;
  color: var(--warn);
  font-size: var(--fs-sm);
}

.error {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius-lg);
  background: var(--error-bg);
  color: var(--error);
  box-shadow: var(--glow-error);
  font-size: var(--fs-sm);
  line-height: 1.4;
}

.alertIcon {
  flex: none;
  margin-top: 1px;
}

.errorList {
  margin: var(--sp-2) 0 0;
  padding-left: var(--sp-6);
}

.notice {
  margin: 0;
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface-sunken);
  color: var(--text-2);
  font-size: var(--fs-md);
  line-height: 1.45;
}

.submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-3);
  width: 100%;
  min-height: 44px;
  margin-top: var(--sp-1);
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--btn-primary-bg);
  border-radius: var(--radius-lg);
  background: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
  font: inherit;
  font-size: var(--fs-lg);
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--glow-edge);
  transition:
    background var(--dnd-dur) var(--dnd-ease),
    box-shadow var(--dnd-dur) var(--dnd-ease);
}

.submit:hover:not(:disabled) {
  background: var(--btn-primary-hover);
  border-color: var(--btn-primary-hover);
  box-shadow: var(--glow-edge), var(--glow-primary);
}

.submit:focus-visible {
  box-shadow: var(--focus-ring), var(--glow-edge), var(--glow-primary);
}

.submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 700ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
    /* Без вращения кольцо нечитаемо как индикатор — оставляем точку. */
    border-top-color: currentColor;
    opacity: 0.5;
  }
}

.foot {
  margin: 0;
  padding: var(--sp-5) var(--sp-7) var(--sp-7);
  border-top: var(--bw) solid var(--border);
  color: var(--text-3);
  font-size: var(--fs-xs);
  line-height: 1.45;
  text-align: center;
}

/* ── Телефон (порог продублирован в ui/shell/useIsMobile.ts) ─────────────── */
@media (max-width: 720px) {
  .head {
    padding: var(--sp-7) var(--sp-5) var(--sp-5);
  }

  .tabs,
  .backRow {
    margin-inline: var(--sp-5);
  }

  .form {
    padding-inline: var(--sp-5);
  }

  .foot {
    padding-inline: var(--sp-5);
  }

  /* Пальцем в 32 пикселя не попасть — растим до рекомендованных 44. */
  .tab,
  .reveal {
    min-height: 44px;
  }

  .reveal {
    width: 44px;
  }
}
